const isDigit = (char: string): boolean => /\d/.test(char);

export const isPhoneField = (value: string): boolean =>
  value
    .split('')
    .every(
      char => ['+', ' ', '(', ')', '-', '_'].includes(char) || isDigit(char),
    );
